import { render, staticRenderFns } from "./AdendumContract.vue?vue&type=template&id=61f3fa4c&"
import script from "./AdendumContract.vue?vue&type=script&lang=js&"
export * from "./AdendumContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports